import { render, staticRenderFns } from "./AttachmentPreview.vue?vue&type=template&id=5c07dece&scoped=true&"
import script from "./AttachmentPreview.vue?vue&type=script&lang=js&"
export * from "./AttachmentPreview.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentPreview.vue?vue&type=style&index=0&id=5c07dece&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c07dece",
  null
  
)

export default component.exports